import { createSlice } from '@reduxjs/toolkit';
import { GEOFENCE_SETTINGS } from '../constants/SlicesName';

const initialState = {
    geofenceLocations: null,
    geofenceRegisteredDevices: null,
    usedInMeshbots: {
        isLoading: false,
        error: null,
        hasOfflineControllers: false,
        locations: {
            cloud: [],
            local: [],
        },
    },
};

export const geofenceSlice = createSlice({
    name: GEOFENCE_SETTINGS,
    initialState,
    reducers: {
        updateGeofenceLocations: (state, action) => {
            state.geofenceLocations = action.payload.data;
        },
        updateGeofenceRegisteredDevices: (state, action) => {
            state.geofenceRegisteredDevices = action.payload.data;
        },
        setUsedInMeshbotsLoading: (state, action) => {
            state.usedInMeshbots.isLoading = action.payload;
        },
        setUsedInMeshbotsError: (state, action) => {
            state.usedInMeshbots.error = action.payload;
        },
        setHasOfflineControllers: (state, action) => {
            state.usedInMeshbots.hasOfflineControllers = action.payload;
        },
        setCloudUsedLocations: (state, action) => {
            state.usedInMeshbots.locations.cloud = action.payload;
        },
        setLocalUsedLocations: (state, action) => {
            state.usedInMeshbots.locations.local = action.payload;
        },
    },
});

export const {
    updateGeofenceLocations,
    updateGeofenceRegisteredDevices,
    setUsedInMeshbotsLoading,
    setUsedInMeshbotsError,
    setHasOfflineControllers,
    setCloudUsedLocations,
    setLocalUsedLocations,
} = geofenceSlice.actions;
export default geofenceSlice.reducer;
